import * as Config from '../../../../config';
import React from 'react';
import PropTypes from 'prop-types';

function ColumnTime({ width, duration = null, durationMs = null, style }) {
  return (
    <div className={`type-placeholder`} style={{ width, ...style }}>{ (duration) ? duration : Config.msToFormatTime(durationMs) }</div>
  )
}

ColumnTime.propTypes = {
  width: PropTypes.number.isRequired,
  duration: PropTypes.string,
  durationMs: PropTypes.number,
  style: PropTypes.object,
}

export default ColumnTime;
